export default __webpack_public_path__ + "images/23010c2e55dd8f7d778fb3aeec681c82.png";